<template>
  <div class="modal-wrapper">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button class="close" @click="$emit('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Abrir solicitação de trancamento de matrícula
          </h4>
        </div>

        <div class="modal-body">
          <div :class="{ 'has-error': interruptionSolicitationForm.errors.length }">
            <label>Motivo da solicitação</label>
            <select v-model="interruptionSolicitationForm.fields.disallowedReason.value" class="form-control">
              <option :value="null" disabled>
                Selecione um motivo...
              </option>
              <option
                v-for="(disallowedReason, index) in disallowedReasons"
                :value="disallowedReason.value"
                :key="index"
              >
                {{ disallowedReason.label }}
              </option>
            </select>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-danger" @click="submit()">
            Abrir solicitação
          </button>
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import ContractPreferencesService from 'services/ContractPreferencesService';
import { FormGroup } from 'utils/form';

export default {
  props: {
    contactPreferenceId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      interruptionSolicitationForm: new FormGroup({
        disallowedReason: { required: true, value: null },
      }),
      disallowedReasons: [],
    };
  },
  mounted() {
    this.$loader.show();
    this.loadDisallowedReasons()
      .then((disallowedReasons) => {
        this.disallowedReasons = disallowedReasons;
      })
      .catch(() => {
        this.$emit('close');
        this.$alert.notifyAlert('Erro ao buscar motivos de solicitações de abertura de trancamento, tente novamente');
      })
      .finally(() => {
        this.$loader.hide();
      });
  },
  methods: {
    ...mapActions(['loadDisallowedReasons']),
    submit() {
      if (this.interruptionSolicitationForm.validateForm()) {
        this.$loader.show();
        ContractPreferencesService.openEnrollmentInterruptionSolicitation(
          this.contactPreferenceId, this.interruptionSolicitationForm.getRawValue(),
        )
          .then(() => {
            this.$alert.notifySuccess('Solicitação de trancamento de matrícula enviada com sucesso.');
            this.$emit('interruption-solicitation-opened');
          })
          .catch(() => {
            this.$alert.notifyAlert('Erro ao abrir solicitação, tente novamente');
          })
          .finally(() => {
            this.$loader.hide();
          });
      }
    },
  },
};
</script>
